<div class="cumulio-container" *ngIf="showReport">
  <iframe  title="report" [src]="safeURL" style="border:0;width:100%;height:1200px" allowfullscreen
    sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"></iframe>
</div>